
//src/Components/MovieForm/index.jsx
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import MovieModal from './MovieModal'; // Adjust the path as needed
import { supabase } from "../../supabaseClient";
import Swal from "sweetalert2";
import { minioClient } from "../../minioClient";
import { PutObjectCommand } from "@aws-sdk/client-s3";
import Stepper from "./Stepper";
import StepBasicMetadata from "./StepBasicMetadata";
import StepFinalDetails from "./StepFinalDetails";
import StepImageUpload from "./StepImageUpload";
import StepAdditionalMetadata from "./StepAdditionalMetadata";
import Button from "../Button";
import { useNavigate, useParams } from "react-router-dom"; //<--- added useParams
import { BiData, BiLoaderCircle, BiUpload } from "react-icons/bi";
import { useLocation } from "react-router-dom"; // Added for navigation state
import { getCurrentUser } from "../currentUser";
import { searchCastMembers, searchGenres, searchLanguages, searchSources, searchContentTypes, searchDirectors } from "../../services/supabase/lookupService";
import axios from "axios";
import { CiDatabase } from "react-icons/ci";
import { MdReviews } from "react-icons/md";



const PINNED_DEFAULTS = {
  poster: 0,
  portrait: 0,
  longPortrait: 0,
  background: 0,
  banner: 0,
  square: 0,
  featureBanner: 0,
  heroBanner: 0,
  titleLogo: 0,
};

const MovieForm = ({ editTile, fetchTails, setShowModal, searchQuery, fromRow = false }) => {
  const [formData, setFormData] = useState({
    //id: null, // or undefined for new tiles
    tileType: "type1",
    tid: Date.now(),
    title: "",
    poster: [],
    portrait: [],
    longPortrait: [],
    background: [],
    banner: [],
    square: [],
    featureBanner: [],
    heroBanner: [],
    landscapePoster: [],
    mainBanner: [],

    titleLogo: [],
    rating: "",
    runtime: "",
    startIndex: "",
    target: "",
    // tags: "",
    type: "",
    
    //for old tvs if not found anything then search for alternate url and make it true 
    useAlternate: false,
    alternateUrl: "",
    playstoreUrl: "",
    package: "",
    detailPage: false,
    source: "",
    languages: [],
    contentType: [],
    genre: [],
    year: "",
    director: [],
    cast: [],
    tags: [],
    imdb_id: "",
    synopsis: "",
    showTileInfo: false,
    tileWidth: "",
    tileHeight: "",

    playstoreUrl: "",   // ✅ add
    package: "",        // ✅ add
  });
  const [genreOptions, setGenreOptions] = useState([]);
  const [languagesOptions, setLanguagesOptions] = useState([]);
  const [imdbId, setImdbId] = useState("");
  const [loadingImdb, setLoadingImdb] = useState(false);

  const [showPreview, setShowPreview] = useState(null);
  const [movieData, setMovieData] = useState(null);

  const [movieCache, setMovieCache] = useState({}); // { imdbId: movieData }
  const [cachedMovie, setCachedMovie] = useState({ imdbId: null, data: null });
  const [initialLoading, setInitialLoading] = useState(true);

  const location = useLocation();
  const effectiveFromRow = fromRow || location.state?.fromRow || false;

  const DEFAULT_BG_URL =
    "https://images.do.cloudwalker.tv/images/globalbg/default_bg.webp";

  const OLD_DEFAULT_BG_URL =
    "https://images.do.cloudwalker.tv/images/tiles/1765357802692/background/PercyJacksonAndTheOlympians2_1920x1080.webp";

  const normalizeBackground = (arr) =>
    arr.map(url => url === OLD_DEFAULT_BG_URL ? DEFAULT_BG_URL : url);

  const parseISOToHHMMSS = (dur) => {
    if (!dur || typeof dur !== 'string') return "";
    const match = dur.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return dur; // fallback to original if not ISO
    const hours = parseInt(match[1] || 0);
    const mins = parseInt(match[2] || 0);
    const secs = parseInt(match[3] || 0);
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const IMAGE_BASE_URL = "https://images.do.cloudwalker.tv/images/";


  const getImageUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path; // already full URL
    return IMAGE_BASE_URL + path;
  };



  // Helper function to ensure contentType exists in Supabase
  const ensureContentTypeExists = async (type) => {
    if (!type) return null;
    const { data, error } = await supabase
      .from("contentType")
      .select("id, contentType")
      .eq("contentType", type)
      .single();

    if (data) return data.id;

    const { data: newType, error: insertError } = await supabase
      .from("contentType")
      .insert([{ contentType: type }])
      .select()
      .single();

    if (insertError) {
      console.error("Failed to insert content type:", insertError);
      return null;
    }

    // Update contentTypeOptions to include the new type
    setContenttypeOptions((prev) => [
      ...prev,
      { label: newType.contentType, value: newType.id },
    ]);
    return newType.id;
  };

  // Helper function to ensure castMember exists in Supabase
  const ensureCastMemberExists = async (name) => {
    if (!name) return null;
    const { data, error } = await supabase
      .from("castMembers")
      .select("id, castMembers")
      .eq("castMembers", name)
      .single();

    if (data) return data.id;

    const { data: newCast, error: insertError } = await supabase
      .from("castMembers")
      .insert([{ castMembers: name }])
      .select()
      .single();

    if (insertError) {
      console.error("Failed to insert cast member:", insertError);
      return null;
    }

    // For async cast dropdown, no need to update static options
    // New casts will appear in next search/paginate
    console.log("New cast member created:", newCast);
    return newCast.id;
  };


  // Helper function to ensure director exists in Supabase
  const ensureDirectorExists = async (name) => {
    if (!name) {
      console.warn("No director name provided, skipping.");
      return null;
    }
    console.log("Checking director in Supabase:", name);

    try {
      const { data, error } = await supabase
        .from("directors")
        .select("id, directors")
        .eq("directors", name)
        .maybeSingle();

      if (error) {
        console.error("Error checking director:", error);
        return null;
      }

      if (data) {
        console.log("Found existing director:", data);
        return data.id;
      }

      console.log("Inserting new director:", name);
      const { data: newDirector, error: insertError } = await supabase
        .from("directors")
        .insert([{ directors: name }])
        .select()
        .single();

      if (insertError) {
        console.error("Failed to insert director:", insertError);
        return null;
      }

      console.log("Inserted new director:", newDirector);
      setDirectorsOptions((prev) => {
        const updatedOptions = [
          ...prev,
          { label: newDirector.directors, value: newDirector.id },
        ];
        console.log("Updated directorsOptions:", updatedOptions);
        return updatedOptions;
      });

      return newDirector.id;
    } catch (err) {
      console.error("Unexpected error in ensureDirectorExists:", err);
      return null;
    }
  };



  // Helper function to ensure genre exists in Supabase
  const ensureGenreExists = async (genre) => {
    if (!genre || typeof genre !== "string") return null;
    console.log("Generes", genre)

    try {
      const { data, error } = await supabase
        .from("genres")
        .select("id, genres")
        .eq("genres", genre); // removed maybeSingle

      if (error) {
        console.error("Error checking genre:", error);
        return null;
      }

      if (data && data.length > 0) {
        console.log("Found existing genre:", data[0]);
        return data[0].id; // pick the first if duplicates exist
      }

      // Insert new genre if none found
      const { data: newGenre, error: insertError } = await supabase
        .from("genres")
        .insert([{ genres: genre }])
        .select()
        .single();

      if (insertError) {
        console.error("Failed to insert genre:", insertError);
        return null;
      }

      console.log("Inserted new genre:", newGenre);

      setGenreOptions((prev) => [
        ...prev,
        { label: newGenre.genres, value: newGenre.id },
      ]);

      return newGenre.id;
    } catch (err) {
      console.error("Unexpected error in ensureGenreExists:", err);
      return null;
    }
  };






  const ensureLanguageExists = async (name) => {
    if (!name) return null;
    const trimmed = name.trim();
    const { data } = await supabase
      .from("languages")
      .select("id, languages")
      .ilike("languages", trimmed)
      .maybeSingle();
    if (data) return data.id;

    const { data: newLang, error: insertError } = await supabase
      .from("languages")
      .insert([{ languages: trimmed }])
      .select()
      .single();
    if (insertError) return null;
    setLanguagesOptions((prev) => [
      ...prev,
      { label: newLang.languages, value: newLang.id },
    ]);
    return newLang.id;
  };

  const parseOMDBRuntime = (runtime) => {
    if (!runtime || runtime === "N/A") return "";
    const match = runtime.match(/(\d+)\s*min/);
    if (!match) return "";
    const totalMins = parseInt(match[1]);
    const h = Math.floor(totalMins / 60);
    const m = totalMins % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:00`;
  };

  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    mode: "cors",
    credentials: "omit"
  };


  const handleFetchMovie = async () => {
    if (!imdbId) {
      Swal.fire({
        icon: "warning",
        title: "Missing IMDb ID",
        text: "Please enter a valid IMDb ID",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      return;
    }

    setLoadingImdb(true);

    try {
      const { data } = await axios.get(process.env.REACT_APP_OMSDB, {
        params: {
          i: imdbId,
          apikey: process.env.REACT_APP_IMDB_KEY,
        },
      });

      if (!data || Object.keys(data).length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Data",
          text: "No movie data found for this ID.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        return;
      }

      if (data.Response === "False") {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.Error || "No movie found for this IMDb ID.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        return;
      }

      const splitCSV = (str) =>
        str && str !== "N/A"
          ? str.split(",").map((s) => s.trim()).filter(Boolean)
          : [];

      const contentTypeId = await ensureContentTypeExists(data.Type);
      const contentType = contentTypeId
        ? [{ label: data.Type, value: contentTypeId }]
        : [];

      const [cast, director, genre, languages] = await Promise.all([
        Promise.all(
          splitCSV(data.Actors).map(async (name) => {
            const id = await ensureCastMemberExists(name);
            return id ? { label: name, value: id } : null;
          })
        ).then((r) => r.filter(Boolean)),

        Promise.all(
          splitCSV(data.Director).map(async (name) => {
            const id = await ensureDirectorExists(name);
            return id ? { label: name, value: id } : null;
          })
        ).then((r) => r.filter(Boolean)),

        Promise.all(
          splitCSV(data.Genre).map(async (name) => {
            const id = await ensureGenreExists(name);
            return id ? { label: name, value: id } : null;
          })
        ).then((r) => r.filter(Boolean)),

        Promise.all(
          splitCSV(data.Language).map(async (name) => {
            const id = await ensureLanguageExists(name);
            return id ? { label: name, value: id } : null;
          })
        ).then((r) => r.filter(Boolean)),
      ]);

      const rating =
        data.imdbRating && data.imdbRating !== "N/A"
          ? data.imdbRating
          : data.Ratings?.[0]?.Value || "";

      setFormData((prev) => ({
        ...prev,
        imdb_id: data.imdbID || imdbId,
        title: data.Title || "",
        year: data.Year?.split("–")[0] || "",
        runtime: parseOMDBRuntime(data.Runtime),
        rating,
        synopsis: data.Plot && data.Plot !== "N/A" ? data.Plot : "",
        portrait: data.Poster && data.Poster !== "N/A" ? [data.Poster] : prev.portrait,
        country: data.Country && data.Country !== "N/A" ? data.Country : prev.country,
        writer: data.Writer && data.Writer !== "N/A" ? data.Writer : prev.writer,
        cast: cast.map((c) => c.value),
        contentType: contentType.map((c) => c.value),
        director: director.map((d) => d.value),
        genre: genre.map((g) => g.value),
        languages: languages.map((l) => l.value),
      }));

      Swal.fire({
        icon: "success",
        title: "Movie Loaded",
        text: `${data.Title || "Movie"} details fetched successfully!`,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } catch (err) {
      // axios throws on non-2xx status codes automatically
      const message =
        err.response?.data?.Error ||
        err.response?.statusText ||
        err.message ||
        "Something went wrong";

      Swal.fire({
        icon: "error",
        title: err.response ? `Error ${err.response.status}` : "Network Error",
        text: message,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } finally {
      setLoadingImdb(false);
    }
  };




  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [contentTypeOptions, setContenttypeOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [clickedStatus, setClickedStatus] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [tagsOptions, setTagsOptions] = useState([]); // 👈 start empty


  // NEW: dynamic options from DB (cast now async search - empty state)
  const [castMembersOptions, setCastMembersOptions] = useState([]);
  const [directorsOptions, setDirectorsOptions] = useState([]);


  // Check if user came from recent-tiles to redirect back there
  const shouldRedirectToRecentTiles = location.state?.fromRecentTiles || false;


  const navigate = useNavigate();

  const [pinnedImageIndex, setPinnedImageIndex] = useState(PINNED_DEFAULTS);

  const minioBaseUrl = "https://images.do.cloudwalker.tv/images/";
  // const minioBaseUrl = "";



  const handleNext = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };
  const { id } = useParams(); //<-- added id from useparams

  // Maps an image path (as stored in formData[field], e.g. "tiles/abc.webp")
  // to the row(s) in row_data whose row_items pinned this tile's image to
  // that path — used to warn/block deleting an image still in use on a row.
  const [pinnedRowRefs, setPinnedRowRefs] = useState({});

  useEffect(() => {
    if (!id || !formData.tid) return;
    let cancelled = false;

    const fetchPinnedRowRefs = async () => {
      const { data, error } = await supabase.from("row_data").select("id, row_header, row_items");
      if (error || cancelled) return;

      const parseRowItems = (rowItems) => {
        const arr = Array.isArray(rowItems)
          ? rowItems
          : typeof rowItems === "string"
            ? (() => {
                try {
                  const parsed = JSON.parse(rowItems);
                  return Array.isArray(parsed) ? parsed : [];
                } catch {
                  return [];
                }
              })()
            : [];

        return arr
          .map((item) => {
            if (item && typeof item === "object") return item;
            if (typeof item === "string") {
              try {
                return JSON.parse(item);
              } catch {
                return null;
              }
            }
            return null;
          })
          .filter(Boolean);
      };

      const map = {};
      (data || []).forEach((row) => {
        parseRowItems(row.row_items).forEach((item) => {
          if (item.image && String(item.tid) === String(formData.tid)) {
            if (!map[item.image]) map[item.image] = [];
            map[item.image].push({ id: row.id, row_header: row.row_header });
          }
        });
      });

      if (!cancelled) setPinnedRowRefs(map);
    };

    fetchPinnedRowRefs();
    return () => {
      cancelled = true;
    };
  }, [id, formData.tid]);


  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 500); // 300–500ms feels smooth

    return () => clearTimeout(timer);
  }, []);

  // Reset pins only when the actual tile changes (not on every parent re-render)
  useEffect(() => {
    if (!editTile?.tid) return;
    setPinnedImageIndex(PINNED_DEFAULTS);
  }, [editTile?.tid]);

  useEffect(() => {
    if (!editTile) return;

    const safeParse = (val) => {
      try {
        if (!val) return [];
        if (Array.isArray(val)) return val.filter(Boolean);
        if (typeof val === "string") {
          const trimmed = val.trim();
          if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
            const parsed = JSON.parse(trimmed);
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [val];
          }
          return [val]; // plain string — wrap in array
        }
        return [val];
      } catch {
        return val ? [val] : [];
      }
    };

    const loadContentTypeLabels = async (uuids) => {
      if (!Array.isArray(uuids) || uuids.length === 0) return [];
      const { data, error } = await supabase
        .from("contentType")
        .select("id, contentType")
        .in("id", uuids);
      if (error) {
        console.error("Error fetching contentType labels:", error);
        return [];
      }
      // For display options if needed, but set formData to UUIDs
      return uuids; // Return UUIDs for storage
    };

    const convertToOptionObjects = (arr) =>
      Array.isArray(arr)
        ? arr.filter(Boolean).map((item) => ({ label: item, value: item }))
        : [];

    // Async because of query
    const updateFormData = async () => {
      const contentTypeUuids = await loadContentTypeLabels(editTile.contentType || []);
      setFormData((prev) => ({
        ...prev,
        ...editTile,
        languages: editTile.languages || [],
        contentType: contentTypeUuids, // UUID array only
        // genre: Array.isArray(editTile.genre)
        //   ? editTile.genre.map((gen) => gen.id || gen)
        //   : [],
        genre: Array.isArray(editTile.genre)
          ? editTile.genre.map((g) => (typeof g === "string" ? g : g.value ?? g.id))
          : [],

        source: Array.isArray(editTile.source)
          ? editTile.source.map((src) => src.id || src)
          : [],
        // cast: convertToOptionObjects(editTile.cast),
        cast: Array.isArray(editTile.cast)
          ? editTile.cast.map(id => String(id)) // ONLY UUIDs
          : [],
        director: convertToOptionObjects(editTile.director),
        poster: safeParse(editTile.poster),
        portrait: safeParse(editTile.portrait),
        longPortrait: safeParse(editTile.longPortrait),

        background: normalizeBackground(safeParse(editTile.background)),
        banner: safeParse(editTile.banner),
        square: safeParse(editTile.square),
        featureBanner: safeParse(editTile.featureBanner || []),
        heroBanner: safeParse(editTile.heroBanner || []),
        landscapePoster: safeParse(editTile.landscapePoster || []),
        mainBanner: safeParse(editTile.mainBanner || []),
        titleLogo: safeParse(editTile.titleLogo || []),
      }));
    };

    updateFormData();
  }, [editTile]);

  useEffect(() => {
    if (!id) return;




    const fetchTile = async () => {
      const { data, error } = await supabase
        .from("tiles")
        .select("*")
        .eq("tid", id)
        .single();

      if (error) {
        console.error("Failed to fetch tile:", error);
        return;
      }

      if (data) {
        const safeParse = (val) => {
          try {
            if (!val) return [];
            if (Array.isArray(val)) return val.filter(Boolean).map(String);
            if (typeof val === "string") {
              const trimmed = val.trim();
              if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [val];
              }
              return [val]; // plain string — wrap in array
            }
            return [String(val)];
          } catch {
            return val ? [String(val)] : [];
          }
        };

        // Fetch lookup tables
        const { data: castRows } = await supabase
          .from("castMembers")
          .select("id, castMembers");
        const { data: directorRows } = await supabase
          .from("directors")
          .select("id, directors");

        // Build maps
        const castMap = {};
        castRows?.forEach((c) => {
          castMap[c.id] = c.castMembers;
        });
        const directorMap = {};
        directorRows?.forEach((d) => {
          directorMap[d.id] = d.directors;
        });

        // Resolve cast and director
        const cast = Array.isArray(data.cast)
          ? data.cast.map((c) => ({
            label: castMap[c] || c,
            // value: castMap[c] || c,
            value: c,

          }))
          : [];
        const director = Array.isArray(data.director)
          ? data.director.map((d) => ({
            label: directorMap[d] || d,
            // value: directorMap[d] || d,
            value: d,                          // ✅ ALWAYS UUID

          }))
          : [];

        setFormData({
          ...formData,
          ...data,
          // languages: data.languages || [],
          // contentType: data.contentType || [],
          languages: ensureArray(data.languages),

          contentType: (() => {
            const parsed = ensureArray(data.contentType);

            return parsed
              .map((val) => {
                const clean = String(val).trim().toLowerCase();

                // 1️⃣ match by UUID
                const byUuid = contentTypeOptions.find((opt) => opt.value === val);
                if (byUuid) return byUuid.value;

                // 2️⃣ match by readable name
                const byName = contentTypeOptions.find(
                  (opt) => opt.label?.toLowerCase() === clean
                );
                if (byName) return byName.value;

                // fallback
                return val;
              })
              .filter(Boolean);
          })(),


          genre: Array.isArray(data.genre)
            ? data.genre.map((gen) => gen.id || gen)
            : [],
          source: Array.isArray(data.source)
            ? data.source.map((src) => src.id || src)
            : [],
          cast,
          director,
          poster: safeParse(data.poster),
          portrait: safeParse(data.portrait),
          longPortrait: safeParse(data.longPortrait),

          background: normalizeBackground(safeParse(data.background)),
          banner: safeParse(data.banner),
          square: safeParse(data.square),
          featureBanner: safeParse(data.featureBanner || []),
          heroBanner: safeParse(data.heroBanner || []),
          landscapePoster: safeParse(data.landscapePoster || []),
          mainBanner: safeParse(data.mainBanner || []),
          titleLogo: safeParse(data.titleLogo || []),
          tags: (() => {
            try {
              if (!data.tags) return [];
              const parsed = typeof data.tags === "string" ? JSON.parse(data.tags) : data.tags;
              return Array.isArray(parsed) ? parsed.map(String) : [String(parsed)]; // Ensure strings
            } catch {
              return [];
            }
          })(),
        });

        // Auto-fill alternateUrl/playstoreUrl/package from source if tile fields are empty
        const sourceIds = Array.isArray(data.source) ? data.source : [];
        if (sourceIds.length > 0 && !data.alternateUrl && !data.playstoreUrl) {
          const { data: sourceData } = await supabase
            .from("source")
            .select("alternate_url, playstore_url, package")
            .eq("id", sourceIds[0])
            .single();

          if (sourceData) {
            setFormData(prev => ({
              ...prev,
              alternateUrl: sourceData.alternate_url || "",
              playstoreUrl: sourceData.playstore_url || "",
              package: sourceData.package || prev.package || "",
            }));
          }
        }
      }
    };

    fetchTile();
  }, [editTile]);



  useEffect(() => {
    const fetchContentType = async () => {
      const { data, error } = await supabase
        .from("contentType")
        .select("id, contentType");
      if (!error && data) {
        const formatted = data.map((item) => ({
          label: item.contentType,
          value: item.id,
        }));
        setContenttypeOptions(formatted);
      }
    };



    const fetchLanguages = async () => {
      const { data, error } = await supabase
        .from("languages")
        .select("id, languages");
      if (!error && data) {
        const formatted = data.map((item) => ({
          label: item.languages,
          value: item.id,
        }));
        setLanguagesOptions(formatted);
      }
    };

    const fetchGenres = async () => {
      const { data, error } = await supabase
        .from("genres")
        .select("id, genres");
      if (!error && data) {
        const formatted = data.map((item) => ({
          label: item.genres,
          value: item.id,
        }));
        setGenreOptions(formatted);
      }
    };







    const fetchDirectors = async () => {
      const { data, error } = await supabase
        .from("directors")
        .select("id, directors");
      if (error) {
        console.error("Error fetching directors:", error);
        return;
      }

      setDirectorsOptions(
        data.map((item) => ({
          label: item.directors,   // readable name
          value: item.id,          // uuid
        }))
      );
    };


    // Static fetches removed for async dropdowns
    // fetchContentType();
    // fetchLanguages();
    // fetchGenres();
    // fetchDirectors();
  }, []);


  useEffect(() => {
    let timer;

    const waitForStableUI = async () => {
      // wait one render cycle (mapping kicks in)
      await new Promise((r) => setTimeout(r, 0));

      // wait a bit more so async mapping settles
      timer = setTimeout(() => {
        setInitialLoading(false);
      }, 800); // tweak 800–1500ms if needed
    };

    waitForStableUI();

    return () => clearTimeout(timer);
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };


  const handleRemoveImage = (type, index) => {
    const currentPin = pinnedImageIndex[type] ?? 0;
    const updatedPinnedIndex =
      currentPin > index ? currentPin - 1 : currentPin === index ? 0 : currentPin;

    setFormData((prev) => {
      const updatedArray = [...prev[type]];
      updatedArray.splice(index, 1);
      return { ...prev, [type]: updatedArray };
    });

    setPinnedImageIndex((prev) => ({ ...prev, [type]: updatedPinnedIndex }));
  };

  const BANNER_IMAGE_FIELDS = ["banner", "featureBanner", "heroBanner"];

  // Moves one image between the Masthead/Feature/Hero banner groups (drag-and-drop
  // reassignment in StepImageUpload) — a plain reorder when source/dest match.
  const moveBannerImage = (sourceField, destField, sourceIndex, destIndex) => {
    if (!BANNER_IMAGE_FIELDS.includes(sourceField) || !BANNER_IMAGE_FIELDS.includes(destField)) return;

    setFormData((prev) => {
      const sourceList = [...(prev[sourceField] || [])];
      const [moved] = sourceList.splice(sourceIndex, 1);
      if (moved === undefined) return prev;

      if (sourceField === destField) {
        sourceList.splice(destIndex, 0, moved);
        return { ...prev, [sourceField]: sourceList };
      }

      const destList = [...(prev[destField] || [])];
      destList.splice(destIndex, 0, moved);
      return { ...prev, [sourceField]: sourceList, [destField]: destList };
    });

    setPinnedImageIndex((prev) => ({ ...prev, [sourceField]: 0, [destField]: 0 }));
  };



  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (!files.length) return;

    const newFiles = Array.from(files);
    const hadNoImages = (formData[name]?.length ?? 0) === 0;

    setFormData((prev) => ({
      ...prev,
      [name]: [...prev[name], ...newFiles],
    }));

    // Keep the existing pin on new uploads; only auto-pin when the field was empty.
    if (hadNoImages) {
      setPinnedImageIndex((prev) => ({ ...prev, [name]: 0 }));
    }
  };

  // Adds a composited (overlay-onto-base) image generated in StepImageUpload
  // as a plain candidate in that field's array — not auto-pinned, so the
  // admin reviews it alongside the other images and pins it deliberately.
  const handleAddGeneratedImage = (field, file) => {
    setFormData((prev) => ({
      ...prev,
      [field]: [...(prev[field] || []), file],
    }));
  };






  useEffect(() => {
    const fetchTags = async () => {
      const { data, error } = await supabase.from("tiles").select("tags");

      if (error) {
        console.error("Error fetching tags:", error);
        return;
      }

      if (data) {
        const allTags = data.flatMap((row) => {
          if (!row.tags) return [];

          if (Array.isArray(row.tags)) {
            // Already a real array
            return row.tags;
          }

          if (typeof row.tags === "string") {
            // Clean string like ['a','b','c'] → [a,b,c]
            return row.tags
              .replace(/[\[\]'"]+/g, "") // remove [ ] ' "
              .split(",")
              .map((t) => t.trim())
              .filter((t) => t.length > 0);
          }

          return [];
        });

        // Deduplicate + format for react-select
        const uniqueTags = [...new Set(allTags)].map((tag) => ({
          value: tag,
          label: tag,
        }));

        setTagsOptions(uniqueTags);
      }
    };

    fetchTags();
  }, []); // 🔥 add fetchTagsTrigger as dependency



  const handleDropdownChange = async (key, value) => {
    let mappedValue = value;

    console.log("Dropdown change:", key, value);

    // For contentType, genre, source: Store UUIDs (extract .value)
    if (key === "contentType" || key === "genre" || key === "source") {
      mappedValue = Array.isArray(value)
        ? value.filter(Boolean) // No need to map to .value if value is an array of strings
        : value ? [value] : [];
    }

    // Handle form data update
    setFormData((prev) => {
      const updatedForm = { ...prev, [key]: mappedValue };

      // Custom logic for source to update tileType
      // if (key === "source") {
      //   const YOUTUBE_ID = "07e65bb5-5bba-47e6-a02f-f9fcecc3ff33";

      //   // Check if any selected source is NOT the YouTube ID
      //   const hasNonYoutube = Array.isArray(mappedValue) && mappedValue.some(id => id !== YOUTUBE_ID);

      //   updatedForm.tileType = hasNonYoutube ? "START" : "";

      //   console.log("updatedForm.tileType", updatedForm.tileType);
      // }

      if (key === "source") {
        const YOUTUBE_ID = "07e65bb5-5bba-47e6-a02f-f9fcecc3ff33";
        const hasNonYoutube =
          Array.isArray(mappedValue) && mappedValue.some(id => id !== YOUTUBE_ID);

        // Auto assign START only if user hasn't chosen a custom tileType
        // updatedForm.tileType =
        //   (!prev.tileType || prev.tileType === "START" || prev.tileType === "")
        //     ? (hasNonYoutube ? "START" : "")
        //     : prev.tileType;

        updatedForm.type =
          (!prev.type || prev.type === "")
            ? (hasNonYoutube ? "START" : "")
            : prev.type;
      }


      return updatedForm;
    });

    // Auto-fill alternateUrl, playstoreUrl, package from source table when source changes
    if (key === "source" && Array.isArray(mappedValue) && mappedValue.length > 0) {
      const { data: sourceData } = await supabase
        .from("source")
        .select("alternate_url, playstore_url, package")
        .eq("id", mappedValue[0])
        .single();

      if (sourceData) {
        setFormData(prev => ({
          ...prev,
          alternateUrl: sourceData.alternate_url || "",
          playstoreUrl: sourceData.playstore_url || "",
          package: sourceData.package || "",
        }));
      }
    }

    // Handle saving tags if key is 'tags' and formData.id exists
    if (key === "tags" && formData.id) {
      const tagsToSave = Array.isArray(value) ? value : value ? [value] : [];
      const { error } = await supabase
        .from("tiles")
        .update({ tags: JSON.stringify(tagsToSave) }) // Adjust based on column type
        .eq("id", formData.id);

      if (error) console.error("Supabase tag save error:", error);
    }
  };


  const handleStatusSubmit = (status) => async (e) => {
    e.preventDefault();
    setClickedStatus(status);
    setFormData((prev) => ({ ...prev, status }));
    await handleSubmit(e, status);
    setClickedStatus(null);
  };



  const handleSubmit = async (e, status) => {
    e.preventDefault();


    // 🔥 Validation FIRST
    if (!formData.title || formData.title.trim() === "") {
      Swal.close();
      Swal.fire({
        toast: true,
        icon: "error",
        title: "Title is required",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return; // block execution
    }

    if (!formData.source) {
      Swal.close();
      Swal.fire({
        toast: true,
        icon: "error",
        title: "Source is required",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return; // block execution
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const replaceMultipleImages = async (
        files,
        folder,
        currentPaths = [],
        pinnedIndex = 0
      ) => {
        const uploadedPaths = [];
        const reorderedFiles = [...files];

        // bring pinned image to front
        if (pinnedIndex >= 0 && pinnedIndex < reorderedFiles.length) {
          const [pinnedFile] = reorderedFiles.splice(pinnedIndex, 1);
          reorderedFiles.unshift(pinnedFile);
        }

        for (const file of reorderedFiles) {
          if (file instanceof File) {
            const newFileBaseName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;

            const alreadyExists = currentPaths?.some(path => {
              if (typeof path !== "string") return false;
              const existingFileName = path.split("/").pop();
              const existingBaseName = existingFileName.substring(0, existingFileName.lastIndexOf('.')) || existingFileName;
              return existingBaseName === newFileBaseName;
            });

            if (alreadyExists) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: `A file named "${newFileBaseName}" already exists in ${folder}`,
                text: "Rename the file and try again",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
              });
              throw new Error("DUPLICATE_FILE"); // ✅ STOP execution AFTER showing toast
            }
            // const filePath = `tiles/${folder}/${Date.now()}/${file.name}`;
            const filePath = `tiles/${formData.tid}/${folder}/${file.name}`;

            const fileBuffer = await file.arrayBuffer();

            const uploadParams = {
              Bucket: "images",
              Key: filePath,
              Body: fileBuffer,
              ContentType: file.type,
            };
            await minioClient.send(new PutObjectCommand(uploadParams));
            uploadedPaths.push(filePath);
          } else if (typeof file === "string") {
            uploadedPaths.push(file);
          }
        }

        return uploadedPaths;
      };

      // upload/keep existing images
      const posterPaths = await replaceMultipleImages(
        formData.poster,
        "poster",
        formData.poster,
        pinnedImageIndex.poster
      );
      const portraitPaths = await replaceMultipleImages(
        formData.portrait,
        "portrait",
        formData.portrait,
        pinnedImageIndex.portrait
      );
      const longPortraitPaths = await replaceMultipleImages(
        formData.longPortrait,
        "longPortrait",
        formData.longPortrait,
        pinnedImageIndex.longPortrait
      );

      const backgroundPaths =
        formData.background && formData.background.length > 0
          ? await replaceMultipleImages(
            formData.background,
            "background",
            formData.background,
            pinnedImageIndex.background
          )
          : [DEFAULT_BG_URL];

      const bannerPaths = await replaceMultipleImages(
        formData.banner,
        "banner",
        formData.banner,
        pinnedImageIndex.banner
      );
      const squarePaths = await replaceMultipleImages(
        formData.square,
        "square",
        formData.square,
        pinnedImageIndex.square
      );

      const featureBannerPaths = await replaceMultipleImages(
        formData.featureBanner,
        "featureBanner",
        formData.featureBanner,
        pinnedImageIndex.featureBanner
      );
      const heroBannerPaths = await replaceMultipleImages(
        formData.heroBanner,
        "heroBanner",
        formData.heroBanner,
        pinnedImageIndex.heroBanner
      );
      const landscapePosterPaths = await replaceMultipleImages(
        formData.landscapePoster,
        "landscapePoster",
        formData.landscapePoster,
        pinnedImageIndex.landscapePoster
      );
      const mainBannerPaths = await replaceMultipleImages(
        formData.mainBanner,
        "mainBanner",
        formData.mainBanner,
        pinnedImageIndex.mainBanner
      );
      const titleLogoPaths = await replaceMultipleImages(
        formData.titleLogo,
        "titleLogo",
        formData.titleLogo,
        pinnedImageIndex.titleLogo
      );

      const now = new Date();
      const formattedTime = now.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });


      const cleanArray = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr
          .map((x) => {
            if (!x) return null;

            if (typeof x === "string") return x;
            if (typeof x === "number") return String(x);
            if (typeof x === "object") return x.value ?? x.label ?? null;

            return null;
          })
          .filter(Boolean);
      };

      const dataToSubmit = {
        ...formData,
        poster: posterPaths,
        portrait: portraitPaths,
        longPortrait: longPortraitPaths,
        background: backgroundPaths,
        banner: bannerPaths,
        square: squarePaths,
        featureBanner: featureBannerPaths,
        heroBanner: heroBannerPaths,
        titleLogo: titleLogoPaths,
        status,
        startTime: formattedTime,

        // CLEAN FIXED ARRAYS
        languages: cleanArray(formData.languages),
        contentType: cleanArray(formData.contentType),
        genre: cleanArray(formData.genre),
        source: cleanArray(formData.source),
        cast: cleanArray(formData.cast),
        director: cleanArray(formData.director),
        tags: cleanArray(formData.tags),
      };

      // Remove columns that don't exist in the tiles table
      delete dataToSubmit.landscapePoster;
      delete dataToSubmit.mainBanner;


      const castData = formData.cast;
      const directorData = formData.director;

      console.log("cast data =>> ", castData)
      console.log("director data =>> ", directorData)


      // UPDATE if id exists (full page edit mode)
      if (id) {
        const { id: _ignore, ...dataWithoutId } = dataToSubmit;

        const { data, error } = await supabase
          .from("tiles")
          .update({
            ...dataWithoutId,
            updated_by: getCurrentUser(), // ✅ ADD THIS
            updated_at: new Date().toISOString(),
          })
          .eq("tid", id)
          .select();


        if (error) throw new Error(`Data update failed: ${error.message}`);

        setSuccess("Data updated successfully!");

        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Tile updated successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        })
        // navigate("/tile");
        // Navigate to /recent-tiles if user came from there, otherwise to /tile or /row
        if (shouldRedirectToRecentTiles) {
          navigate("/recent-tiles");
        } else {
          navigate(effectiveFromRow ? "/row" : "/tile");
        }
      }
      // INSERT if no id (creating new)
      else {
        const { id: _ignore, ...dataForInsert } = dataToSubmit;

        const { data, error } = await supabase
          .from("tiles")
          .insert([
            {
              ...dataForInsert,
              updated_by: getCurrentUser(), // ✅ ADD THIS
            },
          ])
          .select();


        if (error) throw new Error(`Data insertion failed: ${error.message}`);

        setSuccess("Data saved successfully!");

        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Tile created successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        })
        // navigate("/tile");
        console.log("Navigating, effectiveFromRow =", effectiveFromRow);
        // Navigate to /recent-tiles if user came from there, otherwise to /tile or /row
        if (shouldRedirectToRecentTiles) {
          navigate("/recent-tiles");
        } else {
          navigate(effectiveFromRow ? "/row" : "/tile");
        }
      }
    } catch (err) {
      setError(err.message);
      console.error("Error during submission:", err);
    } finally {
      setLoading(false);
    }
  };




  const viewMovieDetails = async (imdbId) => {


    console.time('fetch-movie');

    console.timeEnd('fetch-movie');
    // Check if cached and same ID
    if (cachedMovie.imdbId === imdbId && cachedMovie.data) {
      setMovieData(cachedMovie.data);
      setShowPreview(true);
      return; // no fetch
    }

    setLoading(true);
    try {
      const res = await fetch(`https://imdb.do.cloudwalker.tv/movie/${imdbId}`, requestOptions);
      if (!res.ok) throw new Error(`Server error: ${res.status} ${res.statusText}`);
      const data = await res.json();
      if (!data || Object.keys(data).length === 0) throw new Error("No movie data found");

      // Cache the new ID + data
      setCachedMovie({ imdbId, data });
      setMovieData(data);
      setShowPreview(true);
    } catch (err) {
      console.error('Fetch error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: err.message,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!editTile || !Array.isArray(editTile.source) || sourceOptions.length === 0) return;

    const mappedValues = editTile.source.map(src => {
      const clean = src?.toString().trim().toLowerCase();

      // 1️⃣ match by readable label (watcho, hotstar…)
      const byName = sourceOptions.find(
        opt => opt.label.toString().trim().toLowerCase() === clean
      );
      if (byName) return byName.value;

      // 2️⃣ match by UUID
      const byUuid = sourceOptions.find(opt => opt.value === src);
      if (byUuid) return byUuid.value;

      return null;
    }).filter(Boolean);

    setFormData(prev => ({
      ...prev,
      source: mappedValues
    }));

  }, [editTile?.source, sourceOptions]);



  useEffect(() => {
    if (!editTile || !Array.isArray(editTile.source) || sourceOptions.length === 0) return;

    const mapped = editTile.source.map(item => {
      const clean = item?.toString().trim().toLowerCase();

      // match by name (case-insensitive)
      const byName = sourceOptions.find(
        opt => opt.label?.toString().trim().toLowerCase() === clean
      );
      if (byName) return byName.value;

      // match by uuid
      const byUuid = sourceOptions.find(opt => opt.value === item);
      if (byUuid) return byUuid.value;

      return null;
    }).filter(Boolean);

    setFormData(prev => ({ ...prev, source: mapped }));
  }, [editTile, sourceOptions]);


  const ensureArray = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      try {
        return JSON.parse(val);
      } catch {
        return [];
      }
    }
    return [];
  };



  return (


    <div className="w-full mx-auto  p-6 h-[calc(100vh-1rem)] overflow-auto bg-gray-50 rounded-xl shadow-lg">
      {initialLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white z-50">
          <BiLoaderCircle className="animate-spin text-4xl text-gray-600" />
        </div>
      )}


      {/* Error & Success */}
      {error && (
        <div className="bg-red-100 text-red-800 p-3 rounded-md mb-4 shadow-sm">
          {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 text-green-800 p-3 rounded-md mb-4 shadow-sm">
          {success}
        </div>
      )}

      {/* Back Button */}
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-5 py-2 shadow hover:shadow-md transition"
          onClick={() => window.history.back()}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      {loadingImdb && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-60 backdrop-blur-md z-50 pointer-events-none">
          <BiLoaderCircle size={90} className="animate-spin text-blue-500" /> {/* Added spin animation */}
        </div>
      )}


      <h1 className="text-xl font-bold mb-2">Enter Your IMDB ID</h1>



      <div className="flex items-center gap-2 mb-6">
        <input
          type="text"
          value={imdbId}
          onChange={(e) => setImdbId(e.target.value)}
          placeholder="tt35661996"
          className="border p-2 rounded-lg flex-1"
        />
        <button
          onClick={() => viewMovieDetails(imdbId)} // Fixed: Use imdbId from state
          disabled={loading || !imdbId}
          className={`p-1 bg-blue-100 text-blue-500 rounded hover:bg-blue-200 transition duration-300 transform hover:scale-110 ${loading || !imdbId ? 'opacity-50 cursor-not-allowed' : ''
            }`}
        >
          <FaEye />
        </button>
        <MovieModal
          isOpen={showPreview}
          onClose={() => setShowPreview(false)} // Fixed: Use setShowPreview
          movieData={movieData}
        />


        <button
          type="button"
          onClick={handleFetchMovie}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
          disabled={loadingImdb}
        >
          {loadingImdb ? <BiLoaderCircle /> : "Fetch"}
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* --- Section 1: Basic Metadata --- */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <h2 className="text-xl font-semibold flex items-center gap-2 mb-4 border-b pb-2">
            <span className="text-blue-500"><CiDatabase /></span> Basic Metadata
          </h2>
          <StepBasicMetadata
            formData={formData}
            handleInputChange={handleInputChange}
            handleDropdownChange={handleDropdownChange}
            sourceOptions={sourceOptions}
            contentTypeOptions={contentTypeOptions}
            setContenttypeOptions={setContenttypeOptions}
            setSourceOptions={setSourceOptions}
            sourceLoadOptions={searchSources}
            contentTypeLoadOptions={searchContentTypes}
          />
        </div>

        {/* --- Section 2: Additional Metadata --- */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <h2 className="text-xl font-semibold flex items-center gap-2 mb-4 border-b pb-2">
            <span className="text-purple-500"><BiData /></span> Additional Metadata
          </h2>
          <StepAdditionalMetadata
            formData={formData}
            handleDropdownChange={handleDropdownChange}
            languagesOptions={languagesOptions}
            genreOptions={genreOptions}
            directorOptions={directorsOptions}
            castOptions={castMembersOptions}
            castLoadOptions={searchCastMembers}
            directorLoadOptions={searchDirectors}
            genreLoadOptions={searchGenres}
            languagesLoadOptions={searchLanguages}
            sourceLoadOptions={searchSources}
            tagsOptions={tagsOptions || []}
            setGenreOptions={setGenreOptions}
            setLanguagesOptions={setLanguagesOptions}
            setCastMembersOptions={setCastMembersOptions} // Keep for create
            setDirectorsOptions={setDirectorsOptions}
          />


        </div>

        {/* --- Section 3: Image Upload --- */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <h2 className="text-xl font-semibold flex items-center gap-2 mb-4 border-b pb-2">
            <span className="text-green-500"><BiUpload /></span> Upload Images
          </h2>
          <StepImageUpload
            formData={formData}
            handleFileChange={handleFileChange}
            handleRemoveImage={handleRemoveImage}
            onAddGeneratedImage={handleAddGeneratedImage}
            setPinnedImageIndex={setPinnedImageIndex}
            pinnedImageIndex={pinnedImageIndex}
            moveBannerImage={moveBannerImage}
            minioBaseUrl={minioBaseUrl}
            pinnedRowRefs={pinnedRowRefs}
          // Pass the tileId
          />
        </div>

        {/* --- Section 4: Final Details --- */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <h2 className="text-xl font-semibold flex items-center gap-2 mb-4 border-b pb-2">
            <span className="text-red-500"><MdReviews /></span> Review & Final Details
          </h2>
          <StepFinalDetails
            formData={formData}
            handleInputChange={handleInputChange}
            handleDropdownChange={handleDropdownChange}
            handleStatusSubmit={handleStatusSubmit}
            loading={loading}
            clickedStatus={clickedStatus}
          />
        </div>


      </form>
    </div>
  );
};

export default MovieForm;